import styles from "./Integration.module.scss";

const PreferredPartnerTag = () => (
  <div className={styles["preferred-partner-tag"]}>Preferred Partner</div>
);

const ChromeExtensionTag = () => (
  <div className={styles["tags-container-single"]}>
    <PreferredPartnerTag />
  </div>
);

const GoogleCalTags = () => {
  return (
    <div className={styles["tags-container-single"]}>
      <PreferredPartnerTag />
    </div>
  );
};

const StripeTags = () => {
  return (
    <div className={styles["tags-container-single"]}>
      <PreferredPartnerTag />
    </div>
  );
};

const OutlookTags = () => {
  return (
    <div className={styles["tags-container-single"]}>
      <PreferredPartnerTag />
    </div>
  );
};

const GustoTags = () => {
  return (
    <div className={styles["tags-container-single"]}>
      <PreferredPartnerTag />
    </div>
  );
};

const GoogleMeetTags = () => {
  return <div className={styles["tags-container-single"]}></div>;
};

const ZoomTags = () => {
  return <div className={styles["tags-container-single"]}></div>;
};

const QuickbooksTags = () => {
  return <div className={styles["tags-container-single"]}></div>;
};

const XeroTags = () => {
  return <div className={styles["tags-container-single"]}></div>;
};

type Props = {
  appLabel?: string;
};

const GetTags = ({ appLabel }: Props) => {
  switch (appLabel) {
    case "Chrome Browser Extension":
      return <ChromeExtensionTag />;
    case "Google Calendar":
      return <GoogleCalTags />;
    case "Stripe":
      return <StripeTags />;
    case "Outlook":
      return <OutlookTags />;
    case "Google Meet":
      return <GoogleMeetTags />;
    case "Zoom":
      return <ZoomTags />;
    case "Quickbooks Online":
      return <QuickbooksTags />;
    case "Xero":
      return <XeroTags />;
    case "Gusto":
      return <GustoTags />;
    default:
      return null;
  }
};

export { GetTags };
